import {
  instanceOfAnyOrError
} from './utils/instance-checker';

/**
 * Represents an Entitlement
 */
export default class Entitlement {
  static MAX_TTL = Number.MAX_SAFE_INTEGER;

  constructor(name, enabled = true, ttl = Entitlement.MAX_TTL) {
    this.name = name;
    this.enabled = enabled;
    this.ttl = ttl;
    this.lastLoad = new Date();
  }

  set parent(value) {
    if ((value || null) !== null) instanceOfAnyOrError(value, Entitlement, 'value');
    this._parent = value;
  }

  /**
   * Get the parent value
   */
  get parent() {
    return this._parent;
  }

  /**
   * Gets the full name of this Entitlement
   */
  get fullName() {
    if (!this.parent) return this.name;
    return `${this.parent.fullName}.${this.name}`;
  }

  /**
   * Gets the age in seconds for this Entitlement
   */
  age() {
    return (new Date() - this.lastLoad) / 1000;
  }

  /**
   * Returns true if the age() of this Entitlement is greater than the ttl.
   */
  isExpired() {
    const expired = ((this.ttl || false) !== false && this.age() > this.ttl);
    if (expired) return true;
    return this.parent ? this.parent.isExpired() : false;
  }

  /**
   * Returns true if this Entitlement is recursively enabled
   */
  isEnabled() {
    if (this.enabled === false) return false;
    return this.parent ? this.parent.isEnabled() : true;
  }

  static default(name) {
    return new Entitlement(name, false);
  }
}
